import { Tab, TabPanel, TabPanels, Tabs, TabsList } from '@octano/global-ui';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useRouteMatch } from 'react-router-dom';

import useQuery from '../../../hooks/useQuery';

import GeneralTab from './tabs/GeneralTab';
import InstallmentsTab from './tabs/Installments';

const dictPrefix = 'financialPortal.settings';

enum TabName {
  General = 'general',
  Installments = 'installments',
}

const TAB_ROUTES: { name: TabName; Component: () => JSX.Element }[] = [
  { name: TabName.General, Component: GeneralTab },
  { name: TabName.Installments, Component: InstallmentsTab },
];

/**
 * Configuración de cuenta corriente. La página no trae datos: cada tab y cada
 * sección son autónomos y hacen sus propias llamadas, para que los work items
 * que sumen parámetros no tengan que tocar este archivo más que para agregar
 * una línea.
 */
export default function CurrentAccountSettingsView() {
  const { t } = useTranslation();
  const history = useHistory();
  const { path } = useRouteMatch();
  const params = useQuery();

  const initialTab = useMemo(() => {
    const queryTab = params.get('tab');
    const isValidTab = TAB_ROUTES.some((route) => route.name === queryTab);
    return isValidTab ? (queryTab as TabName) : TabName.General;
  }, [params]);

  const handleTabSelection = (selectedTab: number | string) => {
    history.push({ pathname: path, search: `?tab=${selectedTab}` });
    return null;
  };

  return (
    <div className="mx-3">
      <Tabs defaultTab={initialTab} onSelection={handleTabSelection}>
        <TabsList>
          {TAB_ROUTES.map((route) => (
            <Tab id={route.name} key={route.name}>
              {t(`${dictPrefix}.tabs.${route.name}`)}
            </Tab>
          ))}
        </TabsList>
        <TabPanels>
          {TAB_ROUTES.map(({ Component, name }) => (
            <TabPanel id={name} key={name} children={<Component />} />
          ))}
        </TabPanels>
      </Tabs>
    </div>
  );
}
